import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { LoggedInUser } from '../../auth/logged.in.user';
import { Configuration } from '../../configuration';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../auth/auth.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PagingRequest } from '../../models/common/paging';
import { IPage } from '../../models/common/paging';
import { ContractAwardSummaryDto, ContractAwardDetailsDto } from '../../models/contract.awards/contract.award.models';
import { ContractAwardService } from '../../services/contract.award.service';
import { TenderNote } from '../../models/tenders/tender.models';
import { HvtSection1Dto, HvtSection2Dto, HvtSection4Dto, HvtSection5Dto, HvtSection6Dto } from '../../models/notices/ojeu.notice.models';
import { AwardDetailsDto } from '../../models/contract.awards/contract.award.models';
import { TenderTabInformationDto } from '../../models/tenders/tender.tab.information.model';
import { appInsights } from '../../app.module';
import { SelectableItem } from '../../models/common/selectableItem';

@Component({
    selector: 'ca-results',
    template: require('./results.component.html'),
    styles: [require('./results.component.css')]
})
export class CaResultsComponent implements AfterViewInit, OnDestroy {
    private static readonly ENGLAND_LOCATIONS = [
        'East England',
        'East Midlands',
        'London',
        'North East',
        'North West',
        'South Coast',
        'South East',
        'South West',
        'West Midlands',
        'Yorkshire & Humber'
    ];

    private static readonly UK_LOCATIONS = [
        ...CaResultsComponent.ENGLAND_LOCATIONS,
        'Scotland',
        'Wales',
        'Northern Ireland'
    ];

    private _contractAwards: ContractAwardSummaryDto[];
    contractAwardSelected = false;
    selectedContractAward: ContractAwardDetailsDto;
    selectedContractAwardSummary: ContractAwardSummaryDto;

    pageSizes = [10, 25, 50];

    @BlockUI('tender-details') detailsBlockUi: NgBlockUI;

    @ViewChild('hvtS1', { static: false }) hvtS1Comp: any;
    @ViewChild('hvtS2', { static: false }) hvtS2Comp: any;
    @ViewChild('hvtS4', { static: false }) hvtS4Comp: any;
    @ViewChild('hvtS5', { static: false }) hvtS5Comp: any;
    @ViewChild('hvtS6', { static: false }) hvtS6Comp: any;

    resultsCollapsed = false;
    extrasExpanded = false;
    extrasTab: string;

    addingNote: boolean;
    noteToAdd: string;

    minimumDesktopResolution: number = 1024;

    notesCount: number = 0;
    reminderDto: TenderTabInformationDto = null;

    private readonly user: LoggedInUser;

    resultsScroll;

    @Input()
    options: ITenderResultOptions = {
        availableButtons: []
    };

    @Input()
    set contractAwards(contractAwards: ContractAwardSummaryDto[]) {
        this._contractAwards = contractAwards;

        if (this._contractAwards && this._contractAwards.length > 0) {
            this._contractAwards.forEach((contractAward: any) => contractAward.selected = false);

            if (this.isDesktopMode()) {
                this.showDetails(this._contractAwards[0]);
            }
        }

        if (this.resultsScroll && this.resultsScroll.scrollTo) {
            this.resultsScroll.scrollTo(0, 0);
        }
    }

    @Input() pagingRequest: PagingRequest;
    @Input() page: IPage<any>;

    @Input() sortSelectOptions: Array<SelectableItem<string>> = null;
    @Input() sortValue: string = null;
    @Input() sortDisabled: boolean = false;
    @Output() sortValueChange = new EventEmitter<string>();

    @Output() onResultRemoved = new EventEmitter<any>
        ();
    @Output() onMultipleResultsRemoved = new EventEmitter<any>();
    @Output() onBookmarkChanged = new EventEmitter<any>();

    constructor(private readonly loggedInUserService: LoggedInUserService,
        public configuration: Configuration,
        private readonly accountService: AccountService,
        private readonly authService: AuthService,
        private readonly contractAwardService: ContractAwardService) {
        this.user = loggedInUserService.getCurrentUser();
    }

    onSortSelectionChange(): void {
        if (this.sortDisabled) {
            return;
        }
        this.sortValueChange.emit(this.sortValue);
    }

    ngAfterViewInit() {
        this.resultsScroll = document.getElementById('results-scroll');
    }

    ngOnDestroy() {
        this.resultsScroll = null;
        $('#next-modal').modal('hide');
    }

    get contractAwards() {
        return this._contractAwards;
    }

    isDesktopMode(): boolean {
        return window.innerWidth > this.minimumDesktopResolution;
    }

    showButton(name: string) {
        return this.options.availableButtons.indexOf(name) > -1;
    }

    hasSelectedContractAwards(): boolean {
        return !!this.contractAwards && this.contractAwards.some((contractAward: any) => contractAward.selected);
    }

    showDetails(award: ContractAwardSummaryDto) {
        this.contractAwardSelected = true;
        this.selectedContractAwardSummary = award;

        appInsights.trackEvent({
            name: 'ContractAwardSelected',
            properties: {
                tenderId: award.b2BRef,
                pagePath: window.location.href
            }
        });

        if (this.selectedContractAward && this.selectedContractAward.id === award.b2BRef) {
            return;
        }

        if (!this.isDesktopMode()) {
            document.querySelector('body').classList.add('fixed-scrolling');
        }

        this.reminderDto = new TenderTabInformationDto();
        this.reminderDto.supplierId = this.user.userId;
        this.reminderDto.noticeId = award.b2BRef;
        this.contractAwardService.getTabCount(this.reminderDto)
            .subscribe(x => {
                this.notesCount = x.noteCount;
            });

        this.getContractAwardDetails(award);
    }

    hideDetails() {
        this.contractAwardSelected = false;
        this.selectedContractAward = null;
        document.querySelector('body').classList.remove('fixed-scrolling');
    }

    toggleCollapseResults() {
        this.resultsCollapsed = !this.resultsCollapsed;
    }

    removeResult(event, contractAward) {
        event.stopPropagation();
        this.onResultRemoved.emit(contractAward);
    }

    removeMultiple(event) {
        event.stopPropagation();
        var ids = new Array<string>();
        this.contractAwards.forEach((contractAward: any) => {
            if (contractAward.selected) {
                ids.push(contractAward.id);
            }
        });

        if (ids.length > 0) {
            this.onMultipleResultsRemoved.emit(ids);
        }
    }

    clearSelectedIfMatch(tenderId: number) {
        if (tenderId === this.selectedContractAward.id) {
            this.selectedContractAward = null;
        }
    }

    bookmark(event, award: ContractAwardDetailsDto) {
        event.stopPropagation();
        this.contractAwardService.bookmark(award.id).subscribe(() => {

            if (award.bookmarked) {
                award.bookmarked = false;
                award.bookmarkedById = 0;
                award.jsBookmarkedDate = '';
            }
            else {
                award.bookmarked = true;
                award.bookmarkedById = this.user.userId;
                award.jsBookmarkedDate = new Date().toLocaleString();
            }

            this.onBookmarkChanged.emit(award);
        });
    }

    private getContractAwardDetails(award: ContractAwardSummaryDto) {
        this.detailsBlockUi.start();

        if (this.user.canAdHoc('contractAwardDetails')) {
            this.contractAwardService.getDetails(award.b2BRef).subscribe((response: ContractAwardDetailsDto) => {
                this.extrasExpanded = false;
                var overviewTab = $('#overviewTab');

                if (overviewTab) {
                    overviewTab.click();
                }

                if (this.hvtS1Comp) {
                    this.hvtS1Comp.clear();
                }

                if (this.hvtS2Comp) {
                    this.hvtS2Comp.clear();
                }

                if (this.hvtS4Comp) {
                    this.hvtS4Comp.clear();
                }

                if (this.hvtS5Comp) {
                    this.hvtS5Comp.clear();
                }

                if (this.hvtS6Comp) {
                    this.hvtS6Comp.clear();
                }

                this.selectedContractAward = response;


                this.detailsBlockUi.stop();
            },
                () => { this.detailsBlockUi.stop(); });
        } else {
            this.selectedContractAward = new ContractAwardDetailsDto(true);
            this.selectedContractAward.id = award.b2BRef;

            this.selectedContractAward.b2BTitle = award.title;
            this.selectedContractAward.description = award.description;
            this.selectedContractAward.type = award.type;
            this.selectedContractAward.ojeuSections = award.type === 'Contract Award' ? [1, 2, 4, 5, 6] : [];
            const p = this.selectedContractAward.placeholder;
            this.selectedContractAward.awardDetails = [{
                supplierName: p,
                contact: p,
                address: p
            }];
            this.detailsBlockUi.stop();
        }
    }

    isFreeUser(): boolean {
        return this.user != null && this.user.canAdHoc('notSubscribed');
    }

    isHvtAwardOfContractTab(): boolean {
        return this.showHvtTabs() && this.hasHvtSection(5);
    }

    showAwardOfContractTab(): boolean {
        if (!this.selectedContractAward) {
            return false;
        }
        return this.isHvtAwardOfContractTab()
            || this.selectedContractAward.type === 'Low Value Contract Award'
            || !this.hasHvtSection(1);
    }

    showHvtTabs() {
        return this.selectedContractAward && this.selectedContractAward.type === 'High Value Contract Award';
    }

    hasHvtSection(sectionNumber: number) {
        return this.selectedContractAward.ojeuSections.some(s => {
            return s === sectionNumber;
        });
    }

    onOpenHvtSection(sectionNumber: number) {
        if (this.isFreeUser()) {
            return;
        }
        switch (sectionNumber) {
            case 1:
                {
                    if (!this.selectedContractAward.hvtSection1) {
                        this.contractAwardService.getHvtSection(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: HvtSection1Dto) => {
                                this.selectedContractAward.hvtSection1 = response;

                                this.hvtS1Comp.populate(this.selectedContractAward.hvtSection1,
                                    this.selectedContractAward.ojeuFormType);
                            });
                    }
                    break;
                }
            case 2:
                {
                    if (!this.selectedContractAward.hvtSection2) {
                        this.contractAwardService.getHvtSection(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: HvtSection2Dto) => {
                                this.selectedContractAward.hvtSection2 = response;

                                this.hvtS2Comp.populate(this.selectedContractAward.hvtSection2,
                                    this.selectedContractAward.ojeuFormType);
                            });
                    }
                    break;
                }
            case 4:
                {
                    if (!this.selectedContractAward.hvtSection4) {
                        this.contractAwardService.getHvtSection(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: HvtSection4Dto) => {
                                this.selectedContractAward.hvtSection4 = response;

                                this.hvtS4Comp.populate(this.selectedContractAward.hvtSection4,
                                    this.selectedContractAward.ojeuFormType);
                            });
                    }
                    break;
                }
            case 5:
                {
                    if (!this.selectedContractAward.hvtSection5) {
                        this.contractAwardService.getHvtSection(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: HvtSection5Dto) => {
                                this.selectedContractAward.hvtSection5 = response;

                                this.hvtS5Comp.populate(this.selectedContractAward.hvtSection5,
                                    this.selectedContractAward.ojeuFormType);
                            });
                    }
                    break;
                }
            case 6:
                {
                    if (!this.selectedContractAward.hvtSection6) {
                        this.contractAwardService.getHvtSection(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: HvtSection6Dto) => {
                                this.selectedContractAward.hvtSection6 = response;

                                this.hvtS6Comp.populate(this.selectedContractAward.hvtSection6,
                                    this.selectedContractAward.ojeuFormType, true);
                            });
                    }
                    break;
                }
        }
    }

    onOpenSchema8Section(sectionNumber: number) {
        switch (sectionNumber) {
            case 1:
                {
                    if (!this.selectedContractAward.schema8Section1) {
                        this.selectedContractAward.schema8Section1 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section1 = response.value;
                            });
                    }
                    break;
                }
            case 2:
                {
                    if (!this.selectedContractAward.schema8Section2) {
                        this.selectedContractAward.schema8Section2 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section2 = response.value;
                            });
                    }
                    break;
                }
            case 3:
                {
                    if (!this.selectedContractAward.schema8Section3) {
                        this.selectedContractAward.schema8Section3 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section3 = response.value;
                            });
                    }
                    break;
                }
            case 4:
                {
                    if (!this.selectedContractAward.schema8Section4) {
                        this.selectedContractAward.schema8Section4 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section4 = response.value;
                            });
                    }
                    break;
                }
            case 5:
                {
                    if (!this.selectedContractAward.schema8Section5) {
                        this.selectedContractAward.schema8Section5 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section5 = response.value;
                            });
                    }
                    break;
                }
            case 6:
                {
                    if (!this.selectedContractAward.schema8Section6) {
                        this.selectedContractAward.schema8Section6 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section6 = response.value;
                            });
                    }
                    break;
                }
            case 7:
                {
                    if (!this.selectedContractAward.schema8Section7) {
                        this.selectedContractAward.schema8Section7 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section7 = response.value;
                            });
                    }
                    break;
                }
            case 8:
                {
                    if (!this.selectedContractAward.schema8Section8) {
                        this.selectedContractAward.schema8Section8 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section8 = response.value;
                            });
                    }
                    break;
                }
            case 9:
                {
                    if (!this.selectedContractAward.schema8Section9) {
                        this.selectedContractAward.schema8Section9 = '';
                        this.contractAwardService.getSchema8Section(this.selectedContractAward.id, sectionNumber).subscribe(
                            (response: any) => {
                                this.selectedContractAward.schema8Section9 = response.value;
                            });
                    }
                    break;
                }
        }
    }

    splitMultiLine(obj: string, lineBreak: string = '<br/>') {
        if (obj) {
            return obj.split(lineBreak);
        }
        return [];
    }

    split2(obj: string, lineBreak: string = '<br/>') {
        if (obj) {
            return obj.split(lineBreak);
        }
        return [];
    }

    displayOrNotProvided(value: any) {
        if (value === null || value === undefined) {
            return 'not provided';
        }

        const text = `${value}`.trim();
        return text.length > 0 ? text : 'not provided';
    }

    getDisplayLocation(value: string): string {
        if (value === null || value === undefined) {
            return value;
        }

        const source = `${value}`.trim();
        if (!source) {
            return source;
        }

        const selected = new Set(
            source
                .split(',')
                .map(x => x.trim())
                .filter(x => x.length > 0)
        );

        const hasAll = (required: string[]) => required.every(x => selected.has(x));
        if (hasAll(CaResultsComponent.UK_LOCATIONS)) {
            return 'All UK';
        }
        if (hasAll(CaResultsComponent.ENGLAND_LOCATIONS)) {
            return 'All England';
        }
        return source;
    }

    onOpenAwardDetails() {
        if (this.isFreeUser()) {
            return;
        }
        this.contractAwardService.getAwardDetails(this.selectedContractAward.id)
            .subscribe((result: AwardDetailsDto[]) => {
                this.selectedContractAward.awardDetails = result;
            });
    }

    addNote() {
        this.contractAwardService.addNote(this.selectedContractAward.id, this.noteToAdd).subscribe(() => {
            const note = new TenderNote();
            note.content = this.noteToAdd;
            note.createdBy = this.user.fullName;
            const now = new Date();

            var day = now.getDate() < 10 ? `0${now.getDate()}` : `${now.getDate()}`;
            // < 9 for month since months are an array 0 - 11
            var month = now.getMonth() < 9 ? `0${now.getMonth() + 1}` : `${now.getMonth() + 1}`;

            var hour = now.getHours() < 10 ? `0${now.getHours()}` : `${now.getHours()}`;
            var min = now.getMinutes() < 10 ? `0${now.getMinutes()}` : `${now.getMinutes()}`;

            note.jsCreated = `${day}/${month}/${now.getFullYear()} ${hour}:${min}`;

            this.selectedContractAward.notes.unshift(note);

            this.noteToAdd = null;
            this.addingNote = false;
        });
    }

    showNoteEditor() {
        this.addingNote = true;
    }

    cancelNewNote() {
        this.addingNote = false;
        this.noteToAdd = null;
    }

    openExtrasTab(name: string) {
        this.extrasExpanded = true;
        this.extrasTab = name;
    }

    activeTab(name: string) {
        return this.extrasTab === name;
    }

    closeExtras() {
        this.extrasExpanded = false;
        this.extrasTab = null;
    }

    onSearchComplete() {
        document.getElementById('results-scroll').scrollTop = 0;
    }

    notTeamMember(): boolean {
        return (this.user.role === 'Supplier');
    }

    get viewAwardHref(): string | null {
        if (!this.selectedContractAward) {
            return null;
        }

        const s = this.selectedContractAward.secureUrl;
        const u = this.selectedContractAward.url;
        if (s && s.trim().length > 0) {
            return s;
        }
        if (u && u.trim().length > 0) {
            return u;
        }
        return null;
    }

    get notesText(): string {
        return (this.notesCount <= 0 ? '' : ` (${this.notesCount})`);
    }

    whatToDoNext() {
        $('#next-modal').modal();
    }
}

export interface ITenderResultOptions {
    availableButtons: string[];
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/results.component.ts